<template>
  <div>
    <activity-redirect-item
        :loan-tasks="tasks"
        :current-loan-task="currentTaskName"
        :is-loan-task="true"
        :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <data-table-stage-config-activity-provider></data-table-stage-config-activity-provider>
  </div>
</template>
<script>

import LoanScopeDataHolder from "@/data/model/LoanScopeDataHolder";

import ActivityRedirectItem from "../layout/ActivityRedirectItem";
import {Activities} from "@/utils/ActivityNavigator";
import DataTableStageConfigActivityProvider
  from "@/components/providers/DataTableStageConfigActivityProvider";

export default {
  name: "AssetDetailsActivity",
  components: {ActivityRedirectItem, DataTableStageConfigActivityProvider},

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.SUB_PRODUCT_DETAILS];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
          ? LoanScopeDataHolder.getCurrentLoanTask().name : "";
    }
  }

}
</script>

<style scoped></style>
